import { render, staticRenderFns } from "./PrivacyMicker.vue?vue&type=template&id=54b092fe&scoped=true"
import script from "./PrivacyMicker.vue?vue&type=script&lang=js"
export * from "./PrivacyMicker.vue?vue&type=script&lang=js"
import style0 from "./PrivacyMicker.vue?vue&type=style&index=0&id=54b092fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b092fe",
  null
  
)

export default component.exports